enum Effectiveness {
  Effective,
  NotEffective,
  SuperEffective,
}

export default Effectiveness;
